var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_core.js
// module id = 23
// module chunks = 168707334958949